import { render, staticRenderFns } from "./IconBar.vue?vue&type=template&id=60ff88af&lang=html&"
import script from "./IconBar.vue?vue&type=script&lang=js&"
export * from "./IconBar.vue?vue&type=script&lang=js&"
import style0 from "./IconBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports